import { useTranslation } from '@thoughtspot/i18n';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import React, { useMemo } from 'react';
export const ErrorDetailsModal = ({ isOpen, onClose, errors, isLoading, }) => {
    const { t } = useTranslation();
    const { errorDetail, errorCode, ErrorMsgCode } = errors;
    const closeButtonProps = useMemo(() => ({
        text: t('CLOSE'),
        onClick: () => onClose(),
    }), [errors, onClose]);
    const modalButtons = useMemo(() => {
        const dismissButtonProps = closeButtonProps;
        return {
            dismissButton: dismissButtonProps
                ? {
                    text: dismissButtonProps.text,
                    onClick: dismissButtonProps.onClick,
                }
                : null,
        };
    }, [errors, closeButtonProps]);
    return (React.createElement(Modal, { isOpen: isOpen, title: t('errorDetailsModal.title.ERROR_INFO'), size: ModalSize.SMALL, isContentLoading: isLoading, ...modalButtons },
        React.createElement(Vertical, { spacing: "e" },
            React.createElement(Vertical, { spacing: "a" }, errorCode ? (React.createElement(Typography, { variant: "h5", color: Colors.base }, `${t('errorDetailsModal.header.ERROR_CODE')}${errorCode ? `: ${ErrorMsgCode}` : ''}`)) : null),
            errorDetail ? (React.createElement(Vertical, { spacing: "a" },
                React.createElement(Typography, { variant: "h5", color: Colors.base }, t('errorDetailsModal.header.ERROR_DETAILS')),
                React.createElement(Typography, { variant: "p", color: Colors.base }, errorDetail))) : null)));
};
//# sourceMappingURL=chart-error-modal.js.map